import * as actionTypes from '../types';

export const relationshipsStart = () => ({
    type: actionTypes.RELATIONSHIPS_START,
});

export const relationshipsSuccess = (data) => ({
    type: actionTypes.RELATIONSHIPS_SUCCESS,
    data,
});

export const relationshipsFail = (error) => ({
    type: actionTypes.RELATIONSHIPS_FAIL,
    error,
});

export const getRelationships = (startIndex, stopIndex, searchFilter) => ({
    type: actionTypes.GET_RELATIONSHIPS,
    startIndex,
    stopIndex,
    searchFilter,
});

export const putRelationshipVisibilityStart = () => ({
    type: actionTypes.PUT_RELATIONSHIP_VISIBILITY_START,
});

export const putRelationshipVisibilitySuccess = (payeeAccountId, isHidden) => ({
    type: actionTypes.PUT_RELATIONSHIP_VISIBILITY_SUCCESS,
    payeeAccountId,
    isHidden,
});

export const putRelationshipVisibilityFail = (error) => ({
    type: actionTypes.PUT_RELATIONSHIP_VISIBILITY_FAIL,
    error,
});

export const putRelationshipVisibility = (payeeAccountId, isHidden) => ({
    type: actionTypes.PUT_RELATIONSHIP_VISIBILITY,
    payeeAccountId,
    isHidden,
});
